import React from 'react';
import bg from '../assets/images/splash-bg.png'

const Splash = () => {
    return (
        <div className="splashImageContainer">
            <img alt="Jace Platform" src={bg} className="splashImage" />
        </div>
    );
}

export default Splash;
